import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Box,
} from "@mui/material";
import { useState } from "react";
import { getChoiceItems } from "../apis/RangerOnlineApi";
import { ProductItemSm } from "../components/ProductItemSm";
import { UpSellItem } from "../components/UpSellItem";
import { UpSellItemDialog } from "../dialogs/UpSellItemDialog";

export const UpSellItemCategoryDialog = (props) => {
  const {
    open,
    onClose,
    onProductClick,
    choiceItemsCategories,
    onUpsellItem,
    onNo,
  } = props;
  const [choiceItems, setChoiceItems] = useState([]);
  const [showChoiceItems, setShowChoiceItems] = useState(false);
  const [categoryDescription, setCategoryDescription] = useState("");

  const handleCategoryClick = async (id, categoryName) => {
    const response = await getChoiceItems(id);

    if (response?.status) {
      console.log("error");
      return;
    }

    setChoiceItems(response);
    setShowChoiceItems(true);
    setCategoryDescription(categoryName);
  };

  const handleProductClick = async (categoryId, categoryDescription) => {
    await handleCategoryClick(categoryId, categoryDescription);
  };

  const handleDialogClose = () => {
    setShowChoiceItems(false);
    onUpsellItem();
  };

  return (
    <Dialog open={open} fullWidth={true}>
      <DialogTitle>Did you forget something?</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            overflowY: "scroll",
          }}
        >
          <Grid
            container
            spacing={1}
            /*sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
            }}*/
          >
            {choiceItemsCategories.map((category) => {
              return (
                <UpSellItem
                  key={category.categoryDescription + category.id}
                  id={category.id}
                  name={category.categoryDescription}
                  description={""}
                  price={0}
                  imageUrl={category.imageUrl}
                  onOpen={() =>
                    handleProductClick(
                      category.id,
                      category.categoryDescription
                    )
                  }
                />
              );
            })}
          </Grid>
        </Box>
        {showChoiceItems ? (
          <UpSellItemDialog
            open={showChoiceItems}
            onClose={() => setShowChoiceItems(false)}
            categoryDescription={categoryDescription}
            products={choiceItems}
            onProductClick={onProductClick}
            onDialogClose={handleDialogClose}
          />
        ) : null}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "flex-start" }}>
        <Button variant="contained" color="error" autoFocus onClick={onClose}>
          Yes
        </Button>
        <Button variant="contained" color="error" autoFocus onClick={onNo}>
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};
